// Settings → Sign-in methods API calls. Every link sends a fresh provider credential.
import { isNativePlatform } from './native';
import { ProviderAuthError, getAppleNativeCredential, getGoogleNativeCredential } from './nativeAuth';
import { getAppleWebCredential } from './webIdentity';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const call = async (path, body, method = 'POST') => {
  const res = await fetch(`${API_URL}/api${path}`, {
    method,
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const msg = typeof data?.detail === 'string' ? data.detail : 'Something went wrong. Please try again.';
    throw new ProviderAuthError(msg, data?.code, res.status);
  }
  return data;
};

export const fetchSignInMethods = () => call('/auth/methods', null, 'GET');

export const linkApple = async () => {
  const { nonce } = await call('/auth/link/nonce', {});
  const cred = isNativePlatform() ? await getAppleNativeCredential(nonce) : await getAppleWebCredential(nonce);
  return call('/auth/link/apple', { identityToken: cred.identityToken, nonce });
};

export const linkGoogle = async (webCred) => {
  const cred = webCred || await getGoogleNativeCredential();
  return call('/auth/link/google', { idToken: cred.idToken });
};

export const startEmailLogin = (email) => call('/auth/email/start', { email });
export const confirmEmailLogin = (email, code, password) => call('/auth/email/confirm', { email, code, password });
